import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="px-4 md:px-6 py-10 md:py-14 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-2-line text-lg text-white"></i>
              </div>
              <span className="text-xl font-bold text-white font-heading">屁屁影院</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              免费在线观影平台，提供海量高清电影、电视剧、动漫资源，无需注册即可畅享流畅播放体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 font-heading">快速导航</h4>
            <div className="space-y-2.5">
              <Link to="/" className="block text-sm text-background-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">首页</Link>
              <Link to="/category/movie" className="block text-sm text-background-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">电影</Link>
              <Link to="/category/tv" className="block text-sm text-background-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">电视剧</Link>
              <Link to="/category/anime" className="block text-sm text-background-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">动漫</Link>
              <Link to="/about" className="block text-sm text-background-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 font-heading">热门分类</h4>
            <div className="space-y-2.5">
              <span className="block text-sm text-background-400">科幻电影</span>
              <span className="block text-sm text-background-400">动作电影</span>
              <span className="block text-sm text-background-400">国产剧</span>
              <span className="block text-sm text-background-400">韩剧</span>
              <span className="block text-sm text-background-400">日本动漫</span>
              <span className="block text-sm text-background-400">国产动漫</span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 font-heading">联系我们</h4>
            <div className="space-y-2.5">
              <div className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-mail-line"></i>
                <span>support@ppcinema.com</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-time-line"></i>
                <span>周一至周日 9:00 - 21:00</span>
              </div>
              <div className="flex items-center gap-3 mt-3">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 text-background-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 text-background-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 text-background-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer" aria-label="QQ">
                  <i className="ri-qq-line text-sm"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; 2021-2026 屁屁影院 ppcinema.com 版权所有
          </p>
          <div className="flex items-center gap-4 text-sm text-background-500">
            <span className="cursor-pointer hover:text-background-300 transition-colors">隐私政策</span>
            <span className="cursor-pointer hover:text-background-300 transition-colors">服务条款</span>
            <span className="cursor-pointer hover:text-background-300 transition-colors">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}